import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { GetEventResponseDto } from "../generated/generatedTypes";

const fetchEvent = async (eventId: number): Promise<GetEventResponseDto> => {
  const response = await apiFetch(`api/event/${eventId}`);
  if (!response.ok) {
    throw new Error("이벤트 정보를 불러오지 못했습니다.");
  }
  return response.json();
};

export const useGetEvent = (eventId: number | null) => {
  return useQuery({
    queryKey: ["event", eventId],
    queryFn: () => fetchEvent(eventId!),
    enabled: !!eventId,
  });
};
